import apiClient from "./api";
import { getApiAccessToken } from "./UserService";
import {
  CityObjectPrintoutSearchRequestType,
  CityObjectPrintoutSearchResponseType,
} from "../types/CityObjectPrintout";
import { KkPdfData, PkPdfData, MpkPdfData } from "../types/CityObjectPdfData";
import { pdf } from "@react-pdf/renderer";
import type { DocumentProps } from "@react-pdf/renderer";
import { saveAs } from "file-saver";
import { createElement, ReactElement } from "react";
import KkPDF from "../components/pdf/KkPDF";
import PkPDF from "../components/pdf/PkPDF";
import MpkPDF from "../components/pdf/MpkPDF";

const baseUrl = "/api/CityObjectPrintouts";
const pdfBaseUrl = "/api/CityObjectPdf";

export const searchCityObjectPrintouts = async (
  body: CityObjectPrintoutSearchRequestType,
): Promise<CityObjectPrintoutSearchResponseType> => {
  const token = await getApiAccessToken();
  const response = await apiClient.post(`${baseUrl}/search`, body, {
    headers: { Authorization: `Bearer ${token}` },
  });
  return response.data as CityObjectPrintoutSearchResponseType;
};

export const downloadCityObjectPdf = async (
  perceptionId: number,
  type: "kk" | "pk" | "mpk",
  currentUserId: number,
): Promise<void> => {
  const token = await getApiAccessToken();
  const response = await apiClient.get(
    `${pdfBaseUrl}/${perceptionId}/${type}`,
    {
      headers: { Authorization: `Bearer ${token}` },
      params: { currentUserId },
    },
  );

  const filename = `${type.toUpperCase()}_${perceptionId}.pdf`;

  let doc: ReactElement<DocumentProps>;
  if (type === "kk") {
    doc = createElement(KkPDF, { data: response.data as KkPdfData }) as ReactElement<DocumentProps>;
  } else if (type === "pk") {
    doc = createElement(PkPDF, { data: response.data as PkPdfData }) as ReactElement<DocumentProps>;
  } else {
    doc = createElement(MpkPDF, { data: response.data as MpkPdfData }) as ReactElement<DocumentProps>;
  }

  const blob = await pdf(doc).toBlob();
  saveAs(blob, filename);
};

export const downloadPtrFile = async (
  apiPath: string,
): Promise<void> => {
  const token = await getApiAccessToken();
  const response = await apiClient.get(apiPath, {
    headers: { Authorization: `Bearer ${token}` },
    responseType: "blob",
  });
  const cd = response.headers["content-disposition"] as string | undefined;
  let filename = "PTR_report.txt";
  if (cd) {
    const m = /filename\*?=(?:UTF-8'')?["']?([^"';]+)/i.exec(cd);
    if (m) {
      filename = decodeURIComponent(m[1].trim());
      if (!filename.includes(".")) filename += ".txt";
    }
  }
  const blob = response.data as Blob;
  const url = URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url;
  a.download = filename;
  a.click();
  URL.revokeObjectURL(url);
};
